// extracted by mini-css-extract-plugin
module.exports = {"linkUrl":"Item_linkUrl__2PX4l","remove":"Item_remove__3E77H","details":"Item_details__3N8we"};